export default "__VITE_ASSET__CuPAaBJU__"